"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/require-default-props */
const react_1 = require("react");
const blueprint_1 = require("@groma-dev/blueprint");
const NavItem_module_scss_1 = __importDefault(require("./NavItem.module.scss"));
/**
 * The Nav Item component is an interactive element that acts as a source for navigation.
 * It is capable of acting as a link itself, or opening a Menu containing multiple links.
 *
 * The `<NavItem />` is intended to be used within the `<Toolbar />` or `<MenuSection />` components.
 * @param props
 * @constructor
 */
exports.NavItem = (0, react_1.forwardRef)((_a, ref) => {
    var { as, children, className, testId } = _a, remainingProps = __rest(_a, ["as", "children", "className", "testId"]);
    const Component = as || 'a';
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsx)(Component, Object.assign({ ref: ref, className: (0, blueprint_1.classNames)('Header-navItem-local', className, NavItem_module_scss_1.default.navItem) }, remainingProps, dti, { children: children })));
});
